/**
 * Light obfuscation for the crossword payload.
 *
 * The whole puzzle — including the answers — has to reach the browser for the
 * grid to work offline-ish, so this is NOT security: a determined visitor can
 * always read the answers. It only stops the solution being handed over in
 * plain text in the network tab, which is enough for a daily puzzle.
 *
 * Must stay byte-for-byte compatible with `_encode_payload` in
 * scripts/generate_daily_quiz.py.
 */

const KEY = "leocity-crossword-v1";

function keyBytes() {
  var bytes = [];
  for (var i = 0; i < KEY.length; i++) bytes.push(KEY.charCodeAt(i) & 0xff);
  return bytes;
}

function utf8Encode(str) {
  if (typeof TextEncoder !== "undefined") {
    return Array.prototype.slice.call(new TextEncoder().encode(str));
  }
  var binary = unescape(encodeURIComponent(str));
  var out = [];
  for (var i = 0; i < binary.length; i++) out.push(binary.charCodeAt(i));
  return out;
}

function utf8Decode(bytes) {
  if (typeof TextDecoder !== "undefined") {
    return new TextDecoder("utf-8").decode(new Uint8Array(bytes));
  }
  var binary = "";
  for (var i = 0; i < bytes.length; i++) binary += String.fromCharCode(bytes[i]);
  return decodeURIComponent(escape(binary));
}

function xor(bytes) {
  var k = keyBytes();
  var out = new Array(bytes.length);
  for (var i = 0; i < bytes.length; i++) {
    out[i] = bytes[i] ^ k[i % k.length];
  }
  return out;
}

/** base64 string -> parsed JSON object */
export function decodePayload(encoded) {
  if (!encoded) return null;

  // Already plain JSON? Accept it, so a hand-written test row still works.
  var trimmed = String(encoded).trim();
  if (trimmed.charAt(0) === "{") return JSON.parse(trimmed);

  var binary = atob(trimmed);
  var bytes = new Array(binary.length);
  for (var i = 0; i < binary.length; i++) bytes[i] = binary.charCodeAt(i) & 0xff;
  return JSON.parse(utf8Decode(xor(bytes)));
}

/** JSON-serialisable object -> base64 string (mirror of the Python encoder) */
export function encodePayload(value) {
  var bytes = xor(utf8Encode(JSON.stringify(value)));
  var binary = "";
  for (var i = 0; i < bytes.length; i++) binary += String.fromCharCode(bytes[i]);
  return btoa(binary);
}
